import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { sessionTitleState } from './states';
import { useRecoilState } from 'recoil';
import { StyledButton } from './components/shared/StyledButton';
import aiIcon from './assets/ai-icon.png';
import { useState } from 'react';
import { Col } from 'react-bootstrap';
import { AUTOMOTIVE_SITE } from './shared/constants';

export interface props {
  handleProceed: (e: React.MouseEvent<HTMLButtonElement>) => void
}

function Header({ handleProceed }: props) {
  const [sessionTitle, setSessionTitle] = useRecoilState<string>(sessionTitleState);
  const [showStartTitle, setshowStartTitle] = useState(true);

  const onTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSessionTitle(e.target.value)
  }

  const submitForm = (e: React.MouseEvent<HTMLButtonElement>) => {
    handleProceed(e);
    setshowStartTitle(false);
  }

  return (<>

    {AUTOMOTIVE_SITE.IS_AUTO ?
      (
        <>
          <Container>
            <header className="header">
              <Row>
                <h1 className="title">Vehicle Diagnostic AI (Beta)</h1>
              </Row>
              <Row>
                <h6 className="subtitle">Experience Innova's new Diagnostic Assistant Bot, designed to enhance your vehicle maintenance and repair process. This intelligent tool offers real-time insights and recommendations, helping you understand and address your vehicle's needs more effectively. Try it out today and share your feedback to help us improve your automotive diagnostic experience.</h6>
              </Row>
              <Row>
                <h6 className="subtitle">It is currently being improved, so please give us feedback on how to improve!</h6>
              </Row>
            </header>
          </Container>
          <Container>
            <form id='submit-title-form'>
              <Row md={12} className='title-container'>
                <Col sm md={2}>
                  <label>
                    Conversation Title
                  </label><span className='required'>*</span>
                </Col>
                <Col sm md={5}>
                  <input type='text'
                    placeholder='AUTO216 #32521 Hybrid - <YOUR INITIALS>'
                    onChange={e => onTextChange(e)}
                    required={true}
                    value={sessionTitle}
                    disabled={!showStartTitle} />
                </Col>
              </Row>

              {showStartTitle ? (
                <StyledButton
                  disabled={!sessionTitle}
                  onClick={submitForm}
                  buttonText={'Start Chat'}
                  image={<img src={aiIcon} alt="AI Icon" style={{ width: '24px', height: '24px' }} />}
                  type="submit" />
              ) : null}
            </form>
          </Container>
        </>) : null}
  </>
  );
}

export default Header;